
import * as React from 'react'

const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 30
    const h = 30
    return (
        <svg width={w} height={h} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M13.75 23.75C19.2728 23.75 23.75 19.2728 23.75 13.75C23.75 8.22715 19.2728 3.75 13.75 3.75C8.22715 3.75 3.75 8.22715 3.75 13.75C3.75 19.2728 8.22715 23.75 13.75 23.75Z" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.25 26.25L20.8125 20.8125" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.75 10V17.5" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 13.75H17.5" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default SvgComponent
